<template>
  <v-container
    grid-list-md
    text-xs-center
  >
    <s-all-page />
    <s-app-icon />
  </v-container>
</template>

<script>
import SAllPage from '@/components/SAllPage'
import SAppIcon from '@/components/SAppIcon'

export default {
  components: {
    SAllPage,
    SAppIcon
  }
}
</script>
